import React from 'react'
import "./pages.css";
import { Modal } from 'react-bootstrap';

export default function SpeechToTextModal({show, handleClose, modalStyle}) {
  return (
    <Modal
    id="growthOpportunityModal1"
    show={show}
    onHide={handleClose}
    size=""
    aria-labelledby="example-modal-sizes-title-lg"
    className="ask_analyst_modal"
    centered
    backdrop={true}
    style={modalStyle}
  >
    <Modal.Body>    
    <iframe style={{width:'100%', height:'100vh'}} src="https://intratranscribe.marketsandmarkets.com/transcription" title="description" width="500" height="750" allow="microphone https://intratranscribe.marketsandmarkets.com/transcription"></iframe>    

    </Modal.Body>
  </Modal>
  )
}
